<template>
	<div class="ucenter_page">
		<el-dialog
			title="温馨提示"
			:visible.sync="dialog.accountReminders"
			width="480px"
			append-to-body
			modal-append-to-body
			:close-on-click-modal="false"
			custom-class="account_reminder_dialog_wrap"
			top="110px"
			destroy-on-close
			@closed="onAccountReminderDialogClosed"
		>
			<div class="account_reminder_dialog">
				<p class="account_reminder_tip"><i class="el-icon-warning"></i> 以下账号/应用需要您及时处理，避免影响正常采购与订单同步。</p>
				<div class="account_reminder_block" v-for="(section, sIndex) in accountReminderSections" :key="'section_' + sIndex">
					<p class="account_reminder_label">{{ section.label }}</p>
					<div class="account_reminder_item" v-for="(item, iIndex) in section.items" :key="'item_' + sIndex + '_' + iIndex">
						<span class="account_reminder_type">{{ item.text }}：</span>
						<span class="account_reminder_names">{{ item.names.join('、') }}</span>
					</div>
				</div>
			</div>
			<span slot="footer" class="dialog-footer">
				<el-button @click="dialog.accountReminders = false">我知道了</el-button>
				<el-button type="primary" v-if="hasPurchaseAccountReminder" @click="goPurchaseManage">前往采购管理</el-button>
			</span>
		</el-dialog>
	<div class="wrap">
		<myHead></myHead>
		<div class="wrap_body">
			<div class="center">
				<div class="ucenter_main" v-loading="isLoading">
					<ucMenu num="1"></ucMenu>
					<div class="right_con">
						<div class="dianpu_main">
							<div class="dp_title">
								<p class="fb">我的店铺</p>
								<div class="auth_btn">
									<p class="add_new" @click="openAuthorize(authorize_url)">新增抖店</p>
									<p class="add_new" @click="openAuthorize(kuaidian_authorize_url)">新增快店</p>
								</div>
							</div>
							<ul class="dp_list">
								<li v-for="(item,index) in list" :key="index">
									<div class="logo">
										<img class="coverimg" v-if="item.shop_type==1" src="../../assets/images/logo.png" />
										<img class="coverimg" v-if="item.shop_type==2" src="../../assets/images/kuaidian.png" />
									</div>
									<div class="con_box">
                    <div class="flex items-center justify-between">
                      <p class="dp_name">{{item.shop_name}}</p>

                      <div class="flex items-center justify-center flex-shrink-0">
                      	<el-tooltip class="item" effect="dark" :content="item.vip.name" placement="top">
                      		<img :src="item.vip.icon_url" class="w-4 h-4" />
                      	</el-tooltip>
												
												<template v-if="item.shop_vip_type==1">
													<p class="vip_name" style="margin-top: 0;"><a :href="'./shop_vip?menuId=0&shop_id='+item.shop_id" class="vip_btn">升级</a></p>
												</template>
												<template v-else-if="item.shop_vip_type==3 && item.share_vip_shop_name==item.shop_name">
													<p class="vip_name" style="margin-top: 0;"><a :href="'./shop_vip?menuId=0&shop_id='+item.shop_id" class="vip_btn">升级</a></p>
												</template>
												
                      	
                      </div>
											
                    </div>
										
<!--										<p class="vip_name">{{item.vip.name}} <a :href="'./shop_vip?menuId=0&shop_id='+item.shop_id" class="vip_btn">去升级</a></p>-->
										<p class="dp_time" style="margin-top: 1em;" v-if="item.vip.id != 1">到期时间：{{item.vip.vip_expires_time_text}}</p>
										
										<p class="dp_status">星好货搬家授权状态：
											<span class="red" v-if="item.state_app.val==0">{{item.state_app.text}}</span>
											<span class="green" v-if="item.state_app.val==1">{{item.state_app.text}}</span>
											<a target="_blank" style="margin-left: 10px;" href="https://fxg.jinritemai.com/ffa/mopen/application"><span class="red">续订</span></a>
										</p>
										<p class="dp_time">应用到期时间：{{item.app_expire_time_text}}</p>
										<p class="dp_waring" v-if="item.dd_resources_state!=1">素材库容量不足：<span class="red" @click="bindResourceState(item.shop_id)" style="cursor: pointer;">重置</span>
											<i class="el-icon-warning" style="cursor: pointer;color: #999;margin-left: 5px;" @click="bindResourceTips()"></i>
										</p>
										<p class="btn_auth red" @click="openAuthorize(item.authorize_url)">重新授权</p>
										<br>
										<p class="dd_name">星好货订单授权状态</p>
										<div v-if="item.mod_date_b>0">
											<p class="dp_status" style="margin-top: 10px;">授权状态：
												<span class="red" v-if="item.state_b.val==0">{{item.state_b.text}}</span>
												<span class="green" v-if="item.state_b.val==1">{{item.state_b.text}}</span>
												<a target="_blank" style="margin-left: 10px;" href="https://fxg.jinritemai.com/ffa/mopen/application"><span class="red">续订</span></a>
											</p>
											<p class="dp_time">应用到期时间：{{item.app_expire_time_b_text}}</p>
											<p class="btn_auth red" @click="openAuthorize(item.authorize_url_b)">重新授权</p>
										</div>
										<div v-else>
											<p class="btn_auth blue" @click="openAuthorize(item.authorize_url_b)">立即授权</p>
										</div>
										<br>
										<p class="dd_name">厂商代发授权状态</p>
										<div v-if="item.mod_date_c>0">
											<p class="dp_status" style="margin-top: 10px;">授权状态：
												<span class="red" v-if="item.state_c.val==0">{{item.state_c.text}}</span>
												<span class="green" v-if="item.state_c.val==1">{{item.state_c.text}}</span>
												<a target="_blank" style="margin-left: 10px;" href="https://fxg.jinritemai.com/ffa/mopen/application"><span class="red">续订</span></a>
											</p>
											<p class="dp_time">应用到期时间：{{item.app_expire_time_c_text}}</p>
											<p class="btn_auth red" @click="openAuthorize(item.authorize_url_c)">重新授权</p>
										</div>
										<div v-else>
											<p class="btn_auth blue" @click="openAuthorize(item.authorize_url_c)">立即授权</p>
										</div>
									</div>
									<div class="opts">
										<!-- <span @click="openAuthorize(item.authorize_url)">重新授权</span>
										<em>/</em> -->
										<span @click="bindDel(item.shop_id)">关店</span>
									</div>
								</li>
							</ul>
							<el-empty v-if="page_data.total==0&&!isLoading" description="未添加任何店铺"></el-empty>
						</div>
						<Pagination :total="page_data.total" :page.sync="page_data.page" :limit.sync="page_data.limit" @pagination="getList" />
					</div>
				</div>
			</div>
		</div>
		<!-- <el-dialog title="授权店铺" :visible.sync="dialog.authorizeDialog" width="30%" center >
		  <div class="opts_wrap">
		  	<div class="opts_line">
		  		<p class="txt">抖店service id</p>
		  		<div class="con">
		  			<p class="t"></p>
		  			<el-input class="w180 ml8" v-model="service_id"></el-input>
		  			<p class="t ml8" @click="openAuthorize('https://op.jinritemai.com/docs/question-docs/116/427')">如何获取service id?</p>
		  		</div>
		  	</div>
		  	<div class="btn_wrap">
		  		<p class="btn" @click="doAdd()">去授权</p>
		  		<p class="btn" @click="dialog.authorizeDialog = false">取消</p>
		  	</div>
		  </div>
		</el-dialog> -->
                <el-dialog title="温馨提示" :visible.sync="dialog.productExistCategoryMisplaced" width="30%" :before-close="handleClose">
                        <img class="coverimg" src="../../assets/images/exist_category_misplaced.png" />
                        <p class="pt5">请速修改类目，避免商品下架！</p>
                        <p>你发布的部分商品存在违规发布定邀/定准类目商品的风险，请于12月12日前按推荐申请类目权限并修改，逾期未改商品将下架。<a target="_blank" href="https://school.jinritemai.com/doudian/web/article/aJarZvs6cmWY">查看规则</a></p>
                        <span slot="footer" class="dialog-footer">
                                <el-button type="primary" @click="$router.push('./uc_goods?menuId=120&state=13')">查看详情</el-button>
                                
                        </span>
                </el-dialog>
		<myFoot></myFoot>
	</div>
	</div>
</template>

<script>
import Vue from 'vue';
import { mapActions,mapState,mapMutations } from "vuex";
import { Loading } from 'element-ui';
import myHead from '../../components/myHead/myhead';
import myFoot from '../../components/myFoot/myfoot';
import Pagination from '../../components/pagination/pagination';
import ucMenu from '../../components/ucenterMenu/ucmenu';

export default {
	name: "ucenter",
	data() {
		return {
			isLoading: false,
			list:[],
			page_data: {
				limit: 10,
				page: 1,
				total:0,
			},
			authorize_url:'',
			kuaidian_authorize_url: '',
			dialog: {
				authorizeDialog:false,
                                productExistCategoryMisplaced:false,
				accountReminders: false,
			},
			accountReminderSections: [],
			hasPurchaseAccountReminder: false,
			reminderDialogKey: '',
			pendingPurchaseNavigate: false,
			notify_ids: [],
			service_id:'',
			itv_auto_refresh:0
		}
	},
	created() {
		this.getList()
		this.loadAccountReminders()
		this.autoRefresh()
                this.getDdProductExistCategoryMisplaced();//获取类目不正确的商品
	},
	destroyed() {
		if(this.itv_auto_refresh){
			clearInterval(this.itv_auto_refresh)
		}
	},
	components:{
		myHead,myFoot,ucMenu,Pagination
	},
	methods: {
		...mapActions({
			getDdShopList:"ucenter/getDdShopList",
			getAccountReminders:"ucenter/getAccountReminders",
			opDdShopDel:"ucenter/opDdShopDel",
			opResetResourceState:"ucenter/opResetResourceState",
                        getGoodsList: "ucenter/getGoodsList",
		}),
		...mapMutations({
			OUT_LOGIN:"login/OUT_LOGIN"
		}),
		//自动刷新
		autoRefresh(){
			let that = this
			that.itv_auto_refresh = setInterval(function(){
				that.getList(false)
			},5000)
			
		},
		loadAccountReminders(){
			this.getAccountReminders({
				success: (res) => {
					if (res.code !== 200 || !res.data) {
						return
					}
					this.showAccountReminders(res.data)
				}
			})
		},
		showAccountReminders(data){
			const groups = [
				{ key: 'dd_order_app', label: '抖店订单应用' },
				{ key: 'purchase_account', label: '采购账号' },
			]
			const typeMap = [
				{ field: 'expire_soon', text: '3天内到期' },
				{ field: 'expired', text: '已过期' },
				{ field: 'token_invalid', text: 'token失效' },
				{ field: 'auth_closed', text: '授权已关闭', ddOnly: true },
			]
			const sections = []
			let hasPurchase = false
			groups.forEach(group => {
				const block = data[group.key] || {}
				const items = []
				typeMap.forEach(typeItem => {
					if (typeItem.ddOnly && group.key !== 'dd_order_app') {
						return
					}
					const names = block[typeItem.field] || []
					if (!names.length) {
						return
					}
					items.push({ text: typeItem.text, names: [...names] })
				})
				if (items.length) {
					sections.push({ label: group.label, items })
					if (group.key === 'purchase_account') {
						hasPurchase = true
					}
				}
			})
			if (!sections.length) {
				return
			}
			const dialogKey = JSON.stringify(sections)
			if (this.reminderDialogKey === dialogKey) {
				return
			}
			this.reminderDialogKey = dialogKey
			this.accountReminderSections = sections
			this.hasPurchaseAccountReminder = hasPurchase
			this.dialog.accountReminders = true
		},
		goPurchaseManage(){
			this.pendingPurchaseNavigate = true
			this.dialog.accountReminders = false
		},
		onAccountReminderDialogClosed(){
			this.$nextTick(() => {
				const openBodyDialog = Array.from(document.querySelectorAll('body > .el-dialog__wrapper')).some((wrapper) => {
					return wrapper.style.display !== 'none' && getComputedStyle(wrapper).display !== 'none'
				})
				if (!openBodyDialog) {
					document.querySelectorAll('body > .v-modal').forEach((el) => el.remove())
					document.body.classList.remove('el-popup-parent--hidden')
					document.body.style.paddingRight = ''
				}
			})
			if (this.pendingPurchaseNavigate) {
				this.pendingPurchaseNavigate = false
				this.$router.push('./uc_pdd_manage?menuId=1')
			}
		},
		//获取店铺列表
		getList(showLoading = true){
			if(showLoading) this.isLoading = true
			let param = {limit:this.page_data.limit,page:this.page_data.page,state:this.state}
			Object.assign(param, this.searchData)
			// console.log(param)
			this.getDdShopList({data:param,success:(res)=>{
				if(res.code===200){
					// console.log('get shop list',res)
					this.authorize_url = res.data.authorize_url
					this.kuaidian_authorize_url = res.data.kuaidian_authorize_url
					this.list = res.data.list_data.data

                                        const current_time = new Date().getTime();
                                                                        let index = 0
                                        res.data.list_data.data.map(item => {
                                                if(item.vip_expires_time>0 && ((item.vip_expires_time*1000) - current_time < 0)){
                                                                if(this.notify_ids.findIndex(val => val == item.shop_id)===-1){
                                                                        // this.$message.warning(`${item.shop_name} VIP已到期，请及时续费`);
                                                                        this.$notify({title: '温馨提示',message: `${item.shop_name} VIP已到期，请及时续费`,type: 'warning',offset: 100*index,duration: 0});
                                                                        this.notify_ids.push(item.shop_id);
                                                                        index ++
                                                                }
                
                                                }
                                         })

                                        this.page_data.total = res.data.list_data.total
				} else {
					this.$message({message: res.msg,type: 'error',});
				}
				if(res.code===201){
					this.OUT_LOGIN()
				}
				this.isLoading = false
			}})
		},
                getDdProductExistCategoryMisplaced(){//获取类目不正确的商品
                        let param = {limit:1, page:1, state:13}
			this.getGoodsList({
				data: param, success: (res) => {
					if (res.code === 200) {
						if(res.data.total>0){
                                                        this.dialog.productExistCategoryMisplaced = true
                                                }
					} else {
						this.$message({message: res.msg, type: 'error',});
					}
					this.isLoading = false
				}
			})
                },
		//弹窗授权 废
		bindAdd(){
			this.service_id = ''
			this.dialog.authorizeDialog = true
		},
		//确定授权
		doAdd(){
			let service_id = this.service_id
			if(service_id == ''){
				this.$message({message: '请输入抖店service id',type: 'info',});
				return
			}
			let authorize_url = this.authorize_url+service_id
			this.openAuthorize(authorize_url)
			this.dialog.authorizeDialog = false
		},
		//跳转授权
		openAuthorize(url){
			window.open(url, '_blank')
		},
		//关店
		bindDel(shop_id){
			let that = this
			that.$confirm('确认关闭此店铺吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				if(that.isLoading) return
				that.isLoading = true
				let param = {shop_id:shop_id}
				// console.log(param)
				that.opDdShopDel({data:param,success:(res)=>{
					if(res.code===200){
						// console.log('get shop list',res)
						that.$message({message: res.msg,type: 'success',});
						that.getList()
					} else {
						that.$message({message: res.msg,type: 'error',});
					}
					that.isLoading = false
				}})
			}).catch((res) => {
				console.log(res)
			});
			
		},
		bindResourceTips(){
			let that = this
			that.$alert('素材库容量不足会导致无法正常铺货，请登录抖店后台素材库扩容后在点重置按钮【点击去扩容按钮登录抖店滚到底部左下角扩容】。', '说明', {
				confirmButtonText: '去扩容',
				cancelButtonText:'了解',
				showCancelButton: true,
				type: 'warning'
			}).then((res) => {
				window.open('https://fxg.jinritemai.com/ffa/creative/material_center')
			}).catch((res) => {
			});
		},
		bindResourceState(shop_id){
			let that = this
			that.$confirm('确认店铺素材库已扩容了吗?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then((res) => {
				if(that.isLoading) return
				that.isLoading = true
				let param = {shop_id:shop_id}
				// console.log(param)
				that.opResetResourceState({data:param,success:(res)=>{
					if(res.code===200){
						// console.log('get shop list',res)
						that.$message({message: res.msg,type: 'success',});
						that.getList()
					} else {
						that.$message({message: res.msg,type: 'error',});
					}
					that.isLoading = false
				}})
			}).catch((res) => {
				console.log(res)
			});
		}
	}
}
</script>

<style scoped>
.wrap .wrap_body{display: flex;flex-direction: column;}
.center{display: flex;flex: 1;}
.ucenter_main{padding: 30px 0 40px;display: flex;justify-content: space-between;flex: 1;}

.right_con{width: 980px;background: #fff;}
.dianpu_main{padding: 28px 40px;min-height: 500px;}
.dianpu_main .dp_title{display: flex;justify-content: space-between;align-items: center;}
.dp_title .add_new{width: 74px;height: 34px;box-sizing: border-box;border-radius: 6px;border: 1px solid #f0413e;display: flex;justify-content: center;align-items: center;font-size: 12px;color: #f0413e;cursor: pointer;background: #fff;margin-left: 10px;}
.auth_btn{display: flex;align-items: center;}
.dianpu_main .dp_list{padding-top: 8px;display: flex;flex-wrap: wrap;}
.dp_list>li{width: 290px;min-height: 250px;box-sizing: border-box;border: 1px solid #ddd;border-radius: 6px;background: #fff;padding: 20px;position: relative;display: flex;margin: 14px 14px 0 0;}

.dp_list>li .logo{width: 60px;height: 60px;border-radius: 8px;background: #eee;overflow: hidden;}
.dp_list>li .con_box{flex: 1;width: 0;margin-left: 15px;line-height: 1;}
.dp_list>li .con_box .dp_name{font-weight: bold;}
.dp_list>li .con_box  .vip_name{font-size: 14px;color: #aa007f;font-weight: bold;line-height: 1.2;margin-top: 5px;}
.dp_list>li .con_box  .vip_name .vip_btn{font-weight: normal;cursor: pointer;color: #f0413e;margin-left: 6px;font-size: 12px;}
.dp_list>li .con_box .dp_status{margin-top: 12px;font-size: 12px;color: #666666;}
.dp_list>li .con_box .dp_waring{margin-top: 12px;font-size: 12px;color: #dcbb15;}
.dp_list>li .con_box .dp_time{margin-top: 6px;font-size: 12px;color: #666666;}
.dp_list>li .con_box .dd_name{color: #1b0b1a;font-size: 14px;}
.dp_list>li .opts{position: absolute;bottom: 15px;right: 15px;z-index: 2;font-size: 12px;color: #999;display: flex;align-items: center;}
.dp_list>li .opts>em{font-weight: bold;padding: 0 6px;}
.dp_list>li .opts>span{cursor: pointer;}
.dp_list>li .opts>span:hover{color: #f0413e;}
.btn_auth{cursor: pointer;font-size: 12px;margin-top: 8px;}
.btn_auth:hover{color: #f0413e;}

.opts_wrap{padding-top: 14px;}
	.opts_wrap .opts_line{margin-top: 30px;display: flex;align-items: center;}
	.opts_line .txt{width: 110px;text-align: right;font-size: 14px;}
	.opts_line .con{flex: 1;width: 0;margin-left: 22px;display: flex;align-items: center;}
	.opts_line .con .t{font-size: 14px;color: var(--red);text-decoration: underline;cursor: pointer;}
	.opts_wrap .btn_wrap{margin: 40px auto 0 auto;display: flex;align-items: center;justify-content: center;}
	.opts_wrap .btn_wrap .btn{width: 80px;height: 34px;border-radius: 4px;display: flex;justify-content: center;align-items: center;cursor: pointer;box-sizing: border-box;font-size: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(1){background: var(--red);color: #fff;margin-right: 14px;}
	.opts_wrap .btn_wrap .btn:nth-child(2){background: #fff;color: #333;border: 1px solid #ddd;margin-right: 14px;}
	.ml8{margin-left: 8px;}
	.w180{width: 180px;}
	
	
	/* .el-input--suffix .el-input__inner{padding: 0 0 0 12px !important;font-size: 16px;} */
	/*red border color*/
	.el-input__inner:focus ,.el-select .el-input.is-focus .el-input__inner ,.el-select .el-input__inner:focus ,.el-radio__input.is-checked .el-radio__inner ,.el-radio__inner:hover{border-color: var(--red);}
	
	/*red color*/
	.el-select-dropdown__item.selected ,.el-radio__input.is-checked+.el-radio__label{color: var(--red);}
	
	/*red background color*/
	.el-radio__input.is-checked .el-radio__inner{background-color: var(--red);}
</style>
<style>

.select_wrap .el-button{margin-top: 14px;}
.select_wrap .el-input--prefix .el-input__inner,.select_wrap .el-cascader .el-input .el-input__inner{padding-left: 76px;height: 34px;line-height: 34px;}
.select_wrap .el-select .el-input.is-focus .el-input__inner ,.select_wrap .el-select .el-input__inner:focus{border-color: var(--red);}
.el-select-dropdown__item.selected,.el-cascader-node.in-active-path, .el-cascader-node.is-active, .el-cascader-node.is-selectable.in-checked-path{color: var(--red);}
.select_wrap .el-input--prefix .el-input__inner:focus{border-color: var(--red);}
.select_wrap .el-input__prefix, .el-input__suffix{display: flex;align-items: center;}
.el-button{color: #333;border-color: #ddd;}
.el-button--small{padding: 7px 15px;}
.el-checkbox{color: #666;display: flex;align-items: center;}
.el-checkbox__inner{border-color: #ddd;width: 16px;height: 16px;}
.el-checkbox__input{display: flex;}
.el-checkbox__label{font-size: 12px;line-height: 1;}
.el-checkbox__inner::after{height: 9px;left: 5px;}
.el-checkbox__input.is-indeterminate .el-checkbox__inner::before{height: 4px;}

/*red border color*/
.el-button.is-plain:focus, .el-button.is-plain:hover ,.el-checkbox__inner:hover ,.el-checkbox__input.is-focus .el-checkbox__inner,.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner, .el-pagination__jump .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus,.el-cascader .el-input .el-input__inner:focus, .el-cascader .el-input.is-focus .el-input__inner{border-color: var(--red);}

/*red color*/
.el-button.is-plain:focus, .el-button.is-plain:hover, .el-checkbox__input.is-checked+.el-checkbox__label, .el-pager li.active ,.el-pagination button:hover ,.el-pager li:hover{color: var(--red);}

/*red background color*/
.el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner{background-color: var(--red);}

.el-button:focus, .el-button:hover{border-color: var(--red);color: var(--red);background:#fff;}
.el-button--primary{background: var(--red) !important;color: #fff !important;border-color: #fff;}
.el-button--primary:focus, .el-button:hover{border-color: var(--red);}
.el-loading-spinner .el-loading-text{color:var(--red);}
.el-loading-spinner .path{stroke: var(--red);}

.account_reminder_dialog{line-height: 1.6;color: #333;}
.account_reminder_tip{display: flex;align-items: flex-start;font-size: 14px;color: #666;margin-bottom: 16px;}
.account_reminder_tip .el-icon-warning{color: #e6a23c;font-size: 18px;margin-right: 8px;margin-top: 2px;flex-shrink: 0;}
.account_reminder_block{margin-bottom: 16px;padding: 12px 14px;background: #fff9f0;border-radius: 6px;border: 1px solid #ffe8cc;}
.account_reminder_block:last-child{margin-bottom: 0;}
.account_reminder_label{font-size: 14px;font-weight: bold;color: #333;margin-bottom: 8px;}
.account_reminder_item{font-size: 13px;color: #666;line-height: 22px;margin-top: 4px;}
.account_reminder_type{color: #f0413e;}
.account_reminder_names{color: #333;}

/* 账号提醒弹窗挂 body 顶层，高于固定头部 z-index:2001（仅 CSS，避免 JS 改遮罩导致关闭后残留） */
body > .v-modal:has(+ .el-dialog__wrapper .account_reminder_dialog_wrap) {
	z-index: 3099 !important;
}
.el-dialog__wrapper:has(.account_reminder_dialog_wrap) {
	z-index: 3100 !important;
}
</style>
